// IDP Configuration for Bedrock Chat App

import logger from '../utils/logger';

export const IDP_CONFIG = {
  okta: {
    type: 'okta',
    name: 'Okta',
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
    redirectUri: process.env.REACT_APP_OKTA_REDIRECT_URI || 'https://fathom.healthcostiq.com/login/callback',
    responseType: 'code',
    scope: 'openid profile email',
    enablePKCE: true,
    enableMFA: true,
    enableSSO: true
  }
};

// Get the active IDP configuration
export const getActiveIDPConfig = () => {
  const idpType = process.env.REACT_APP_IDP_TYPE || 'okta';
  const config = IDP_CONFIG[idpType];

  if (!config) {
    logger.warn(`[IDP] Unknown IDP type: ${idpType}, falling back to Okta`);
    return IDP_CONFIG.okta;
  }

  return config;
};
